import S from "./index.module.scss";
import CustomIcon from "@/components/ui/custom-icon";
import { FC, useState } from "react";
import VacanciesItem from "../vacancies-item";
import { VacancyGroupResource } from "@/api/generated-api";

interface IVacanciesList {
  title: string;
  data: VacancyGroupResource[];
}

const VacanciesList: FC<IVacanciesList> = ({ title, data }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={S.wrapper}>
      <h3 className={S.title} onClick={() => setOpen(value => !value)}>
        {title}
        <span className={S.titleButton}>
          <CustomIcon fileName={open ? "icon-minus" : "icon-plus"} />
        </span>
      </h3>
      {open && data.map(vacancy => <VacanciesItem vacancy={vacancy} key={vacancy.id} />)}
      <span className={S.line}></span>
    </div>
  );
};

export default VacanciesList;
